import React from "react";

const Uncheck = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" data-testid="uncheck-icon">
    <circle
      cx={10}
      cy={10}
      r={10}
      transform="translate(2 2)"
      fill="#FFF"
      stroke="#C4C4C4"
      fillRule="evenodd"
    />
  </svg>
);

export default Uncheck;
